import React, { FunctionComponent } from 'react';

import { TextSmall } from 'components/chroma/extended';

import {
  importantInformationUrl,
  toDisplayUrl,
} from 'scenes/common/helpers/contacts';

const PolicyText: FunctionComponent = () => (
  <TextSmall textAlign="left">
    Standard underwriting criteria apply. Coles Supermarkets Australia Pty Ltd
    (Coles) is an authorised representative of the issuer, Insurance Australia
    Limited (ABN 11 000 016 722) (AFSL 227681), part of Insurance Australia
    Group (IAG). Any advice provided is of a general nature only and does not
    take into consideration your objectives, financial situation or needs.
    Before acting on any advice you should consider its appropriateness.
    Consider the Product Disclosure Statement and Target Market Determinations
    available at{' '}
    <a
      href={importantInformationUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {toDisplayUrl(importantInformationUrl())}
    </a>{' '}
    to see if the product is right for you.
  </TextSmall>
);

export default PolicyText;
